module.exports = __webpack_public_path__ + "img/photo-0038.ea4fcf24.jpg";